/**
 * Consistent color scheme for filter chips across filter panel and summary
 */

export const FILTER_COLORS = {
  users: undefined, // Default MUI chip color (no color prop)
  categories: 'primary',
  licenseTypes: 'secondary',
  groups: 'secondary', // Same as licenseTypes since they're mutually exclusive
  activityTypes: 'info',
} as const

export type FilterColorKey = keyof typeof FILTER_COLORS
export type FilterColor = (typeof FILTER_COLORS)[FilterColorKey]
